module.exports = __webpack_public_path__ + "static/preview__heading_mobile-36367d1fbd80ed418dbcfdce16399ce0.png";